import * as React from 'react';
import { compose } from 'ramda';

import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import MainNav from 'src/shared/app/nav/component/main/MainNav';

import styles from './MobileNavBar.style';
import { useDispatch } from 'react-redux';
import {
  registerMobileNav,
  unRegisterMobileNav,
} from 'src/shared/app/nav/slice/navSlice';

const useStyles = createUseThemeStyles(styles);

const MobileNavBar = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(registerMobileNav());
    return () => {
      dispatch(unRegisterMobileNav());
    };
  }, []);

  return (
    <React.Fragment>
      <div className={classes.root}>
        <div className={classes.inner}>
          <MainNav isMobile />
        </div>
      </div>
    </React.Fragment>
  );
};

export default compose(React.memo)(MobileNavBar);
